import script from "./VersionDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionDescription.vue?vue&type=script&setup=true&lang=js"

import "./VersionDescription.vue?vue&type=style&index=0&id=1ef210ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef210ea"]])

export default __exports__